import React from "react";
import { Link } from "react-router-dom";
import "../../styles/CallToAction.css";
const downloadPDF = () => {
  const link = document.createElement("a");
  link.href = "/Diagnostic-Guide.pdf";   // your file path
  link.download = "Diagnostic-Guide.pdf"; // file name for user
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
const CallToAction = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <h4>Ready to Build Control?</h4>

        <h2>Built for founders who know something has to change.</h2>
        <p>
          Start with operational certainty. Book a fit call to assess whether
          the diagnostic makes sense for your business.
        </p>
        <p>
          We are not for everyone. We work with operators who are serious about structure.
           If you want quick fixes, we are not your firm. If you want your business to run on systems — we should talk
        </p>

<div className="cta-buttons">
  
      
              <Link to="/contact" className="btn-2">
                Book a Fit Call
              </Link>
              <div className="download-btn" onClick={downloadPDF}>
    <span className="btn-text">↓ Download Our Diagnostic Guide</span>

    <span className="btn-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"
        />
      </svg>
    </span>
  </div>
  </div>
</div>
    </section>
  );
};

export default CallToAction;
